export default __webpack_public_path__ + "static/media/TT.c32ac509.svg";